import * as path from 'path';

function sanitizePathSegment(segment: string): string {
  return segment
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'item';
}

/** Shared relative path for local disk and future S3, e.g. bayviewyards/food-court/menu-kitchen01.pdf */
export function getFoodCourtMenuRelativePath(
  locationSlug: string,
  itemKey: string,
  fileName: string
): string {
  const ext = path.extname(fileName).slice(1).toLowerCase() || 'pdf';
  const loc = sanitizePathSegment(locationSlug);
  const item = sanitizePathSegment(itemKey);
  return `${loc}/food-court/menu-${item}.${ext}`;
}

/** Public URL path segment under /uploads/food-court/ */
export function getFoodCourtMenuPublicUrl(relativePath: string): string {
  const safe = relativePath
    .split('/')
    .filter((part) => part && part !== '..' && part !== '.')
    .map(encodeURIComponent)
    .join('/');
  return `/uploads/food-court/${safe}`;
}
